type ForgotPasswordFormIds = {
	readonly email: string
	readonly password: string
	readonly passwordConfirm: string
	readonly submit: string
}

// Tracking Location
export const FORGOT_PASSWORD_PAGE_LOCATION = 'forgot_password_page'

// Form IDs
export const FORGOT_PASSWORD_RESET_FORM_ID = 'forgot_password_reset_form'
export const FORGOT_PASSWORD_FORM_ID = 'forgot_password_form'

// Form Types
export const PASSWORD_RESET_FORM_TYPE = 'password_reset'
export const PASSWORD_FORGOT_FORM_TYPE = 'password_forgot'

// Field IDs
export const FORGOT_EMAIL_INPUT_ID = 'forgot_email_input'
export const FORGOT_PASSWORD_INPUT_ID = 'forgot_password_input'
export const FORGOT_PASSWORD_CONFIRMATION_INPUT_ID = 'forgot_password_confirmation_input'

// Submit Button IDs
export const FORGOT_PASSWORD_RESET_SUBMIT_BUTTON_ID = 'forgot_password_reset_submit_button'
export const FORGOT_PASSWORD_SUBMIT_BUTTON_ID = 'forgot_submit_button'

// Other Button IDs
export const FORGOT_BACK_TO_LOGIN_BUTTON_ID = 'forgot_back_to_login_button'

// Form Field Map
export const FORGOT_PASSWORD_FORM_FIELD_IDS = {
	email: FORGOT_EMAIL_INPUT_ID,
	password: FORGOT_PASSWORD_INPUT_ID,
	passwordConfirm: FORGOT_PASSWORD_CONFIRMATION_INPUT_ID,
	submit: FORGOT_PASSWORD_RESET_SUBMIT_BUTTON_ID
} as const satisfies ForgotPasswordFormIds
